import { useEffect } from 'react'
import { App } from 'antd'
import { setModalApi } from 'utils/modalBridge'
import { setMessageApi } from 'utils/messageBridge'
import { setNotificationApi } from 'utils/notificationBridge'

const ModalBridgeRegistrar = () => {
  const { modal, message, notification } = App.useApp()

  useEffect(() => {
    setModalApi(modal)
    setMessageApi(message)
    setNotificationApi(notification)
    return () => {
      setModalApi(null)
      setMessageApi(null)
      setNotificationApi(null)
    }
  }, [modal, message, notification])

  return null
}

export default ModalBridgeRegistrar
